// src/pages/institucional/Estrutura-fisica.tsx
import React, { useState, useEffect } from 'react';
import {
  Box, Typography, useTheme, Tabs, Tab, Grid, Card, CardContent,
  ImageList, ImageListItem, ImageListItemBar, Chip, Stack
} from '@mui/material';
import { Place, Map as MapIcon, PhotoLibrary } from '@mui/icons-material';
import { headerGradient } from '../../theme';

// Tipos
type Foto = { src: string; alt: string; legenda?: string };
type Secao = { nome: string; descricao?: string; fotos: Foto[] };
type Unidade = {
  id: string;
  nome: string;
  endereco?: string;
  mapaEmbed?: string; // iframe embed do Google Maps
  secoes: Secao[];
};

// Dados (exemplos; adicione mapaEmbed para cada unidade quando tiver)
const unidades: Unidade[] = [
  {
    id: 'fatese',
    nome: 'Faculdade  SEDE : Manaus ',
    endereco: 'Rua 10 de Julho, 11 - Centro, Manaus - AM, 69010-060',
    mapaEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d262.9523205745651!2d-60.02727751038553!3d-3.1296367176232933!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926c0f87fc3215f5%3A0x4ca20a44868c5f41!2sFaculdade%20Senac%20Amazonas!5e0!3m2!1spt-BR!2sbr!4v1736881984583!5m2!1spt-BR!2sbr',
    secoes: [
      {
        nome: 'Unidade',
        descricao: 'Ambiente de acolhimento e atendimento aos estudantes e visitantes.',
        fotos: [
          { src: './assets/estrutura/UNIDADES/predio-fatese.png', alt: 'Faculdade Sede Fachada' },
          { src: './assets/estrutura/ESPACO/fatese_entrada.jpg', alt: 'Recepção da Faculdade Sede' },
        ],
      },
      {
        nome: 'Ambientes de Aprendizado',
        descricao: 'Ambientes modernos e equipados para aprendizado e convivência.',
        fotos: [
          { src: './assets/estrutura/ESPACO/sala-fatese.jpg', alt: 'Sala convencional' },
          { src: './assets/estrutura/ESPACO/lab_fatese.jpg', alt: 'Laboratório Tecnológico' },
          { src: './assets/estrutura/ESPACO/biblioteca-sede.jpg', alt: 'Biblioteca Sede' },
        ],
      },
    ],
  },
  {
    id: 'centro-informatica',
    nome: 'Campus  Centro de Informática - Manaus',
    endereco: 'Av. Darcy Vargas, 288 - Chapada, Manaus - AM, 69050-020',
    mapaEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3984.0042509256446!2d-60.02944941629904!3d-3.093527132214716!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926c1011fb87e645%3A0x89625ec11de6b1ab!2sCentro%20Especializado%20de%20Inform%C3%A1tica%20-%20SENAC%20CHAPADA!5e0!3m2!1spt-BR!2sbr!4v1758825627924!5m2!1spt-BR!2sbr',
    secoes: [
      {
        nome: 'Unidade',
        fotos: [
          { src: './assets/estrutura/UNIDADES/predio-cei.png', alt: 'Centro de Informática Fachada' },
          { src: './assets/estrutura/ESPACO/recepcao-cei.jpg', alt: 'Recepção' },
        ],
      },
      {
        nome: 'Ambientes de Aprendizado',
        descricao: 'Estações modernas para práticas em tecnologia.',
        fotos: [
          { src: './assets/estrutura/ESPACO/lab-cei.jpg', alt: 'Laboratório Tecnológico' },
          { src: './assets/estrutura/ESPACO/lab2-cei.jpg', alt: 'Laboratório Tecnológico Mac' },
          { src: './assets/estrutura/ESPACO/sala-microsoft.jpg', alt: 'Laboratório Sala Microsoft' },
          { src: './assets/estrutura/ESPACO/sala-treinamento-cei.jpg', alt: 'Sala de Treinamento' },
          { src: './assets/estrutura/ESPACO/auditorio-cei.jpg', alt: 'Auditório' },
        ],
      },
    ],
  },
  {
    id: 'centro',
    nome: 'Anexo Centro : Manaus ',
    endereco: 'Rua Saldanha Marinho, 410 - Centro, Manaus - AM, 69010-040',
    mapaEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1408.5054937619977!2d-60.023394479421476!3d-3.1329539095931755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926c057cc57050b7%3A0xde8f2e6634f8aa0a!2sCentro%20de%20Educa%C3%A7%C3%A3o%20Profissional%20Fernando%20Alfredo%20Pequeno%20-%20SENAC!5e0!3m2!1spt-BR!2sbr!4v1758826841894!5m2!1spt-BR!2sbr',
    secoes: [
      {
        nome: 'Unidade',
        descricao: 'Ambiente de acolhimento e atendimento aos estudantes e visitantes.',
        fotos: [
          { src: './assets/estrutura/UNIDADES/predio-centro.png', alt: 'Centro Fachada' },
          { src: './assets/estrutura/ESPACO/recepcao-centro.jpg', alt: 'Recepção Unidade Centro' },
        ],
      },
      {
        nome: 'Ambientes de Aprendizado',
        descricao: 'Ambientes modernos e equipados para aprendizado e convivência.',
        fotos: [
          { src: './assets/estrutura/ESPACO/lab-centro.jpg', alt: 'Laboratório Tecnológico Centro' },
          { src: './assets/estrutura/ESPACO/lab_fatese.jpg', alt: 'Laboratório Tecnológico' },
          { src: './assets/estrutura/ESPACO/biblioteca-centro.jpg', alt: 'Biblioteca' },
          { src: './assets/estrutura/ESPACO/lab-saude.jpg', alt: 'Laboratório de Saúde' },
          { src: './assets/estrutura/ESPACO/lab-estetica.jpg', alt: 'Laboratório de Estética' },
          { src: './assets/estrutura/ESPACO/lab-gastronomia.jpg', alt: 'Laboratório de Gastronomia' },
          { src: './assets/estrutura/ESPACO/auditorio-centro.jpg', alt: 'Auditório Centro' },
        ],
      },
    ],
  },
  {
    id: 'parintins',
    nome: 'Campus Parintins',
    endereco: 'Av. Massaranduba. s/nº - Djard Vieiera - Parintins - AM, 69152-320',
    // OBS: seu mapaEmbed original tinha width/height/style dentro da string; mantenha só a URL:
    mapaEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3985.5734360094248!2d-56.75536662430139!3d-2.6432151386162914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x92638347d01a6b85%3A0x48def21b4814eca8!2sAv.%20Massaranduba%20-%20Djard%20Vieira%2C%20Parintins%20-%20AM%2C%2069152-320!5e0!3m2!1spt-BR!2sbr!4v1758814865819!5m2!1spt-BR!2sbr',
    secoes: [
      {
        nome: 'Unidade',
        fotos: [
          { src: './assets/estrutura/UNIDADES/01-PARINTINS_FACHADA.jpg', alt: 'Fachada' },
          { src: './assets/estrutura/UNIDADES/02-PARINTINS_RECEPCAO.jpg', alt: 'Recepção' },
        ],
      },
      {
        nome: 'Ambientes de Aprendizado',
        descricao: 'Ambientes modernos e equipados para aprendizado e convivência.',
        fotos: [
          { src: './assets/estrutura/UNIDADES/03-PARINTINS_SECRETARIA.jpg', alt: 'Secretaria' },
          { src: './assets/estrutura/UNIDADES/04-PARINTINS_SALA-CONVENCIONAL_1.jpg', alt: 'Sala Convencional' },
          { src: './assets/estrutura/UNIDADES/05-PARINTINS_LABORATORIO.jpg', alt: 'Laboratório' },
          { src: './assets/estrutura/UNIDADES/06-PARINTINS_SALA_CONVENCIONAL_2.jpg', alt: 'Sala Convencional 2' },
        ],
      },
      // { nome: 'Recepção', fotos: [{ src: 'https://am.senac.br/wp-content/uploads/2023/05/03-RECEPCAO.jpg', alt: 'Parintins Recepção' }] },
    ],
  },
  {
    id: 'itacoatiara',
    nome: 'Campus Itacoatiara',
    endereco: 'Rua Adamastor de Fegueiredo, 2.207 - Centro, Itacoatiara - AM, 69100-000',
    mapaEmbed:
      'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3983.8005402584045!2d-58.45001592429748!3d-3.147268740493603!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x926f546f68fefc6d%3A0x1a285bddab9e773!2sCentro%20de%20Educa%C3%A7%C3%A3o%20Profissional%20Moys%C3%A9s%20Benarros%20Israel%20-%20SENAC!5e0!3m2!1spt-BR!2sbr!4v1758814548755!5m2!1spt-BR!2sbr',
    secoes: [
      {
        nome: 'Unidade',
        fotos: [
          { src: './assets/estrutura/UNIDADES/01-ITACOATIARA_FACHADA.jpg', alt: 'Fachada' },
          { src: './assets/estrutura/UNIDADES/02-ITACOATIARA_RECEPCAO.jpg', alt: 'Recepção' },
        ],
      },
      {
        nome: 'Ambientes de Aprendizado',
        descricao: 'Ambientes modernos e equipados para aprendizado e convivência.',
        fotos: [
          { src: './assets/estrutura/UNIDADES/03-ITACOATIARA_AUDITORIO.jpg', alt: 'Auditório' },
          { src: './assets/estrutura/UNIDADES/04-ITACOATIARA_BIBLIOTECA.jpg', alt: 'Biblioteca' },
          { src: './assets/estrutura/UNIDADES/05-ITACOATIARA_SALA-CONVENCIONAL.jpg', alt: 'Sala Convencional' },
          { src: './assets/estrutura/UNIDADES/06-ITACOATIARA_LABORATORIO-SAUDE.jpg', alt: 'Laboratório de Saúde' },
          { src: './assets/estrutura/UNIDADES/07-ITACOATIARA_LABORATORIO-TECNOLOGIA.jpg', alt: 'Laboratório de Tecnologia' },
        ],
      },
      // {
      //   nome: 'Laboratórios de Gastronomia',
      //   fotos: [{ src: 'https://am.senac.br/wp-content/uploads/2023/05/10-LAB-GASTRONOMIA.jpg', alt: 'Itacoatiara Lab Gastronomia' }],
      // },
    ],
  },
];

// A11y helpers
function a11yProps(index: number) {
  return { id: `unidade-tab-${index}`, 'aria-controls': `unidade-tabpanel-${index}` };
}
const TabPanel: React.FC<{ value: number; index: number; children: React.ReactNode }> = ({ value, index, children }) => (
  <Box role="tabpanel" hidden={value !== index} id={`unidade-tabpanel-${index}`} aria-labelledby={`unidade-tab-${index}`}>
    {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
  </Box>
);

const EstruturaFisica: React.FC = () => {
  const theme = useTheme();
  const [tab, setTab] = useState(0);     // unidade selecionada
  const [view, setView] = useState(0);   // 0 = Galeria, 1 = Mapa (por unidade)

  // Se a nova unidade não tem mapa, força a view "Galeria"
  useEffect(() => {
    if (!unidades[tab]?.mapaEmbed && view === 1) setView(0);
  }, [tab, view]);

  return (
    <Box sx={{ pt: { xs: 4, md: 6 } }}>
      {/* Cabeçalho */}
      <Box sx={{ px: { xs: 2, md: 6 } }}>
        <Typography
          variant="h4"
          sx={{
            fontWeight: 700,
            mb: 1.5,
            position: 'relative',
            display: 'inline-block',
            pb: 1,
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: 100,
              height: 4,
              backgroundColor: theme.palette.secondary.main,
              borderRadius: theme.shape.borderRadius,
            },
          }}
        >
          Estrutura Física
        </Typography>

        <Typography variant="h6">Faculdade Senac Amazonas</Typography>
        <Typography variant="body2">CNPJ: 03.965.450/0001-07</Typography>
      </Box>

      {/* Tabs de Unidades */}
      <Box sx={{ px: { xs: 2, md: 6 }, mt: 4 }}>
        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v)}
          variant="scrollable"
          scrollButtons="auto"
          aria-label="Unidades"
        >
          {unidades.map((u, idx) => (
            <Tab key={u.id} label={u.nome} {...a11yProps(idx)} />
          ))}
        </Tabs>

        {unidades.map((u, idxU) => (
          <TabPanel key={u.id} value={tab} index={idxU}>
            {/* Endereço */}
            {u.endereco && (
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 2, opacity: 0.9 }}>
                <Place fontSize="small" />
                <Typography variant="body2">{u.endereco}</Typography>
              </Stack>
            )}

            {/* Abas internas: Galeria / Mapa */}
            <Tabs
              value={view}
              onChange={(_, v) => setView(v)}
              sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}
            >
              <Tab icon={<PhotoLibrary fontSize="small" />} iconPosition="start" label="Galeria" />
              <Tab
                icon={<MapIcon fontSize="small" />}
                iconPosition="start"
                label="Mapa"
                disabled={!u.mapaEmbed}
              />
            </Tabs>

            {/* Conteúdo das abas internas */}
            {view === 0 && (
              <Grid container spacing={3}>
                {u.secoes.map((sec) => (
                  <Grid item xs={12} key={`${u.id}-${sec.nome}`}>
                    <Card variant="outlined">
                      <CardContent>
                        <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                          <Chip label={sec.nome} color="primary" />
                          {sec.descricao && (
                            <Typography variant="body2" color="text.secondary">
                              {sec.descricao}
                            </Typography>
                          )}
                        </Stack>

                        <ImageList
                          variant="masonry"
                          cols={4}
                          gap={8}
                          sx={{
                            columnCount: { xs: 1, sm: 2, md: 3, lg: 4 },
                            '& .MuiImageListItem-root': { breakInside: 'avoid' },
                          }}
                        >
                          {sec.fotos.map((foto, idxF) => (
                            <ImageListItem key={idxF}>
                              <img
                                src={foto.src}
                                alt={foto.alt}
                                loading="lazy"
                                style={{ width: '100%', height: 'auto', display: 'block', borderRadius: 8 }}
                              />
                              {(foto.legenda || sec.nome) && (
                                <ImageListItemBar
                                  position="below"
                                  title={foto.legenda || foto.alt}
                                  subtitle={sec.nome}
                                  sx={{ '.MuiImageListItemBar-title': { fontWeight: 600 } }}
                                />
                              )}
                            </ImageListItem>
                          ))}
                        </ImageList>
                      </CardContent>
                    </Card>
                  </Grid>
                ))}
              </Grid>
            )}

            {view === 1 && u.mapaEmbed && (
              <Card variant="outlined">
                <CardContent>
                  <Box
                    sx={{
                      position: 'relative',
                      pt: '56.25%', // 16:9
                      borderRadius: 2,
                      overflow: 'hidden',
                      boxShadow: 1,
                    }}
                  >
                    <Box sx={{ position: 'absolute', inset: 0 }}>
                      <iframe
                        src={u.mapaEmbed}
                        width="100%"
                        height="100%"
                        style={{ border: 0 }}
                        allowFullScreen
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                        title={`Mapa - ${u.nome}`}
                      />
                    </Box>
                  </Box>
                </CardContent>
              </Card>
            )}
          </TabPanel>
        ))}
      </Box>

      {/* Faixa decorativa */}
      <Box
        sx={{
          mt: 6,
          height: 4,
          width: '100vw',
          maxWidth: '100vw',
          ml: 'calc(50% - 50vw)',
          mr: 'calc(50% - 50vw)',
          background: headerGradient,
        }}
      />
    </Box>
  );
};

export default EstruturaFisica;
